export const downloadPdf = async (pdf: string, token?: string, needsBlob = true, documentTitle?: string) => {
  let blobUrl: string | undefined;

  if (needsBlob) {
    const fetchOptions = token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : undefined;

    const response = await fetch(pdf, fetchOptions);

    blobUrl = URL.createObjectURL(await response.blob());
  }

  const link = document.createElement('a');

  link.href = needsBlob && blobUrl ? blobUrl : pdf;
  link.target = '_blank';

  if (documentTitle) {
    link.download = documentTitle;
  }

  document.body.append(link);
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  );
  link.remove();
};
